import { useEffect } from 'react';
import { Admin, Resource, DataProvider } from 'react-admin';

import authProvider from './authProvider';
import themeReducer from './themeReducer';
import { Login, Layout } from './layout';
// import { Dashboard } from './dashboard';
import customRoutes from './routes';
import confSaga from './configuration/confSaga';

import merchants from './merchants';
import merchantsV2 from './merchantsv2';

import financings from './financings'
import financingsV2 from './financingsv2'

import transactions from './transactions';
import collections from './collections';

import platforms from './platforms';
import offers from './offers';
import financialRegimens from './financialRegimens';
import merchantDashboard from './merchantDashboard';
import i18nProvider from './i18n'
import { adminViewsRoles, merchantViewRoles, partnerRoles } from './utils/roles'


const initialState = () => ({
    theme: localStorage.getItem('theme') || 'light',
    admin: {
        ui: {
            sidebarOpen: true
        }
    }
});

interface AppProps {
    onUnmount: () => void;
    dataProvider: DataProvider;
}


const App = ({ onUnmount, dataProvider }: AppProps) => {
    useEffect(() => onUnmount, [onUnmount]);

    return (
        <Admin
            title=""
            dataProvider={dataProvider}
            customReducers={{ theme: themeReducer }}
            customRoutes={customRoutes}
            customSagas={[confSaga]}
            authProvider={authProvider}
            // dashboard={Dashboard}
            loginPage={Login}
            layout={Layout}
            i18nProvider={i18nProvider}
            initialState={initialState}
            disableTelemetry
        >
            {permissions => [
                adminViewsRoles.includes(permissions.defaultRole) && <Resource name="Merchant" {...merchants} />,
                adminViewsRoles.includes(permissions.defaultRole) && <Resource name="Financing" {...financings} />,
                adminViewsRoles.includes(permissions.defaultRole) && <Resource name="Transaction" {...transactions} />,
                adminViewsRoles.includes(permissions.defaultRole) && <Resource name="ConciliationTransaction" />,
                adminViewsRoles.includes(permissions.defaultRole) && <Resource name="Platform" {...platforms} />,
                adminViewsRoles.includes(permissions.defaultRole) && <Resource name="offers" {...offers} />,
                adminViewsRoles.includes(permissions.defaultRole) && <Resource name="financings" {...financingsV2} />,
                adminViewsRoles.includes(permissions.defaultRole) && <Resource name="merchants" {...merchantsV2} />,
                adminViewsRoles.includes(permissions.defaultRole) && <Resource name="collections" {...collections} />,
                adminViewsRoles.includes(permissions.defaultRole) && <Resource name="merchant_banks" />,
                adminViewsRoles.includes(permissions.defaultRole) && <Resource name="merchant_phones" />,
                adminViewsRoles.includes(permissions.defaultRole) && <Resource name="merchant_docs" />,
                adminViewsRoles.includes(permissions.defaultRole) && <Resource name="FinancialRegimen" {...financialRegimens} />,
                merchantViewRoles.includes(permissions.defaultRole) && <Resource name="Transaction" options={{ label: 'MerchantDashboard' }}  {...merchantDashboard} />,
                partnerRoles.includes(permissions.defaultRole) && <Resource name="Merchant" {...merchants} />,
                partnerRoles.includes(permissions.defaultRole) && <Resource name="Financing" {...financings} />,
                partnerRoles.includes(permissions.defaultRole) && <Resource name="Platform" {...platforms} />,
                partnerRoles.includes(permissions.defaultRole) && <Resource name="FinancialRegimen" {...financialRegimens} />,
            ]}
            {/* 
            <Resource
                name="commands"
                {...commands}
                options={{ label: 'Coma' }}x
            /> */}

        </Admin>
    );
};

export default App;
